import includes from 'lodash/includes'
import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import { PaymentIcon as Icon } from '@Globals/Metadata'

const withBorders = ['maestro', 'mc']
const asWider = [
  '4',
  '5',
  'mobilepay',
  'multibanco',
  'paypal',
  'postfinancecw_postfinancecard',
  'postfinancecw_postfinanceefinance',
  'swish-horizontal',
]

const StyledPaymentIcon = styled.div<{ icon: string }>`
  height: 26px;
  width: 50px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;

  ${({ icon, theme }) => includes(withBorders, icon) && css`
    max-width: 40px;
    background-color: #fff;
    border: 1px solid ${theme.colors.greyLighter}
  `}

  ${({ icon }) => includes(asWider, icon) && css`
    width: 70px;
  `}
`

export const PaymentIcon: FC<Icon> = ({ name, url }) => (
  <StyledPaymentIcon
    icon={name}
    style={{ backgroundImage: `url(${url})` }}
  />
)
